/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as TYPES from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const setCommentTab = (data) => {
  if (data === null) {
    return { type: TYPES.COMMENT_TAB_DATA, commentTabObj: {} };
  }
  return { type: TYPES.COMMENT_TAB_DATA, commentTabObj: data };
};
export const dispatchGetAllCommentList = (data) => {
  return {
    commentCorrList: data,
    type: TYPES.GET_ALL_COMMENT_LIST_COMM,
  };
};
export const dispatchSetDisableUpdate = (data) => {
  return {
    disableUpdate: data,
    type: TYPES.DISABLE_UPDATE,
  };
};
export const getAllCommentCorrList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.FETCH_ALL_COMMENTS, value)
    .then((response) => {
      return dispatch(
        dispatchGetAllCommentList(response.data && response.data.data)
      );
    })
    .catch(() => {
      dispatch(dispatchGetAllCommentList([]));
    });
};

export const resetUpdateOrSaveMessage = (message) => (dispatch) => {
  if (message === '') return dispatch(dispatchSaveOrUpdate(message));
  return dispatch(dispatchSaveOrUpdate(''));
};
export const dispatchSaveOrUpdate = (values) => {
  return {
    saveOrUpdateMessage: values,
    type: TYPES.SAVE_OR_UPDATE,
  };
};
export const postSaveOrUpdate = (value) => (dispatch) => {
  if (value === null) {
    return dispatch(dispatchSaveOrUpdate(null));
  }
  return axios
    .post(serviceEndPoint.ADD_UPDATE_COMMENT, value)
    .then((response) => {
      return dispatch(
        dispatchSaveOrUpdate({
          message: 'SUCCESS',
          ...response.data,
        })
      );
    })
    .catch(() => {
      dispatch(dispatchSaveOrUpdate('failed'));
    });
};
export const dispatchDeleteComment = (data) => {
  return {
    deleteCommentMsg: data,
    type: TYPES.DELETE_COMMENT,
  };
};

export const dispatch = (data) => {
  return {
    genrateCommentIdMsg: data.message,
    commentId: data.id,
    type: TYPES.FETCH_GENERATE_SEQ_NUM,
  };
};

export const postSingleDeleteComment = (value) => (dispatch) => {
  if (value === null) {
    return dispatch(dispatchDeleteComment(''));
  }
  return axios
    .post(serviceEndPoint.DELETE_SINGLE_COMMENT, value)
    .then(() => {
      return dispatch(dispatchDeleteComment('SUCCESS'));
    })
    .catch(() => {
      dispatch(dispatchDeleteComment('failed'));
    });
};
export const dispatchGetGeneralSystemParametersResultDetails = (data) => ({
  type: TYPES.GET_GENERAL_SYSTEM_PARAMETER_COMM,
  generalSystemParameter: data,
});
export const getGeneralSystemParameterDetails = (values) => (dispatch) => {
  return axios
    .get(serviceEndPoint.GET_GENERAL_SYSTEM_PARAMETER, values)
    .then((response) => {
      dispatch(
        dispatchGetGeneralSystemParametersResultDetails(
          response.data && response.data.data
        )
      );
    })
    .catch(() => {
      dispatch(dispatchGetGeneralSystemParametersResultDetails([]));
    });
};
export const dispatchCreateSeqNum = (data) => {
  return {
    generateNewSeqId: data,
    type: TYPES.FETCH_GENERATE_SEQ_NUM,
  };
};

export const generateCommentId = (value) => (dispatch) => {
  if (value === null) {
    return dispatch(dispatchCreateSeqNum(null));
  }
  return axios
    .post(serviceEndPoint.FETCH_GENERATE_SEQ_NUM, value)
    .then((response) => {
      return dispatch(
        dispatchCreateSeqNum(response.data && response.data.data)
      );
    })
    .catch(() => {
      dispatch(dispatchCreateSeqNum(null));
    });
};
export const clearReduxForSystemLevelCommCorrespondence = () => (dispatch) => {
  dispatch(setCommentTab({}));
  dispatch(dispatchCreateSeqNum(null));
  dispatch(dispatchGetGeneralSystemParametersResultDetails({}));
  dispatch(dispatchDeleteComment(''));
  dispatch(dispatchSaveOrUpdate(''));
  dispatch(dispatchGetAllCommentList([]));
};
// common poc comment & correspondence
export const dispatchGenerateSeqNum = (data) => {
  return {
    createNewSeqComId: data,
    type: TYPES.CREATE_NEW_SEQ_NUM,
  };
};
export const getCreateSeqNum = (value) => (dispatch) => {
  if (value === null) {
    return dispatch(dispatchGenerateSeqNum(null));
  }
  return axios
    .post(serviceEndPoint.FETCH_GENERATE_SEQ_NUM, value)
    .then((response) => {
      return dispatch(
        dispatchGenerateSeqNum(response.data && response.data.data)
      );
    })
    .catch(() => {
      dispatch(dispatchGenerateSeqNum(null));
    });
};
export const dispatchGetAllCommentListForCommonPoc = (data) => {
  return {
    CommentListData: data,
    type: TYPES.GET_COMMENT_LIST_FOR_COMMON_POC,
  };
};
export const dispatchComment = (data) =>{
  return {
    commentData:data,
    type:TYPES.COMMENT_DATA
  }
}
export const getAllCommentCorrListForCommonPoc = (value) => (dispatch) => {
  if (value === null) {
    dispatch(dispatchGetAllCommentListForCommonPoc([]));
  } else {
    return axios
      .post(serviceEndPoint.FETCH_ALL_COMMENTS, value)
      .then((response) => {
        dispatch(dispatchComment(response.data && response.data.data))
        return dispatch(
          dispatchGetAllCommentListForCommonPoc(
            response.data && response.data.data
          )
        );
      })
      .catch(() => {
        dispatch(dispatchGetAllCommentListForCommonPoc([]));
      });
  }
};

export const getLinksTableData = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_LINK_PRIMARY_TABLES, values)
    .then((response) =>
      dispatch({ type: TYPES.GET_LINK_TABLE_DATA, payload: response.data })
    )
    .catch(() => dispatch({ type: TYPES.GET_LINK_TABLE_DATA, payload: [] }));
};

export const resetUpdateOrSaveMessageForCommonPoc = (message) => (dispatch) => {
  if (message === '')
    return dispatch(dispatchSaveOrUpdateForCommonPoc(message));
  return dispatch(dispatchSaveOrUpdateForCommonPoc(''));
};
export const dispatchSaveOrUpdateForCommonPoc = (values) => {
  return {
    saveOrUpdateMessageByCommonPoc: values,
    type: TYPES.SAVE_OR_UPDATE_FOR_COMMON_POC,
  };
};
export const postSaveOrUpdateForCommonPoc = (value) => (dispatch) => {
  if (value === null) {
    dispatch(dispatchSaveOrUpdateForCommonPoc(null));
  } else {
    return axios
      .post(serviceEndPoint.ADD_UPDATE_COMMENT, value)
      .then((response) => {
        return dispatch(
          dispatchSaveOrUpdateForCommonPoc({
            message: 'SUCCESS',
            ...response.data,
          })
        );
      })
      .catch(() => {
        dispatch(dispatchSaveOrUpdateForCommonPoc('failed'));
      });
  }
};
export const dispatchDeleteCommentForCommonPoc = (data) => {
  return {
    deleteCommentMsgByCommonPoc: data,
    type: TYPES.DELETE_COMMENT_FOR_COMMON_POC,
  };
};
export const postSingleDeleteCommentForCommonPoc = (value) => (dispatch) => {
  if (value === null) {
    dispatch(dispatchDeleteCommentForCommonPoc(''));
  } else {
    return axios
      .post(serviceEndPoint.DELETE_SINGLE_COMMENT, value)
      .then(() => {
        return dispatch(dispatchDeleteCommentForCommonPoc('SUCCESS'));
      })
      .catch(() => {
        dispatch(dispatchDeleteCommentForCommonPoc('failed'));
      });
  }
};
export const clearReduxForCommCorrespondencePopup = () => (dispatch) => {
  dispatch(dispatchGenerateSeqNum(null));
  dispatch(dispatchGetAllCommentListForCommonPoc([]));
  dispatch(dispatchDeleteCommentForCommonPoc(''));
  dispatch(dispatchSaveOrUpdateForCommonPoc(''));
  dispatch(dispatchGetGeneralSystemParametersResultDetails({}));
};
